import { Component, OnInit } from '@angular/core';
import { AlertPaymentService } from '../shared/services/alert-payment.service';
import { isCurrentRouteBlocked } from '../../../old-crazy-web-frontend/src/app/auth/blocked-state-routes';

@Component({
  selector: 'cc-new-app',
  template: `
    <div class="pos-f-t w-lg left-auto pos-rlt z-index-10000">
      <cc-ng1-menu-top
        class="pos-fix dropdown-menu-right d-flex"
        [ngClass]="{ blurred: blurred, 'payment-failed': failedPayment }"
      ></cc-ng1-menu-top>
    </div>
    <router-outlet></router-outlet>
  `
})
export class NewAppComponent implements OnInit {
  failedPayment: boolean;

  constructor(public alertPaymentService: AlertPaymentService) {}

  ngOnInit() {
    this.alertPaymentService.onActivatePaymentAlert.subscribe(isPaymentFailed => {
      this.failedPayment = isPaymentFailed;
    });
  }

  get blurred() {
    return isCurrentRouteBlocked();
  }
}
